<template>
  <div>
    <vs-prompt
      title="Add new data processor"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: NightPay ApS"
                v-model="name"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>VAT Number</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: 37987204"
                v-model="vat"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Street</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: Skindergade 7"
                v-model="street"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Zip code</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: 2550"
                v-model="zip"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: København"
                v-model="city"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>E-mail</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: kontakt@nightpay.dk"
                v-model="email"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Phone</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: +4512345678"
                v-model="phone"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Website</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: https://nightpay.dk"
                v-model="website"
              />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      vat: "",
      street: "",
      city: "",
      zip: "",
      website: "",
      email: "",
      phone: "",
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return (
        this.name !== "" &&
        this.vat !== "" &&
        this.street !== "" &&
        this.city !== "" &&
        this.zip !== "" &&
        this.website !== "" &&
        this.email !== "" &&
        this.phone !== ""
      );
    },
  },
  methods: {
    show() {
      this.name = "";
      this.vat = "";
      this.street = "";
      this.city = "";
      this.zip = "";
      this.website = "";
      this.email = "";
      this.phone = "";
      this.prompt = true;
    },
    async accept() {
      const dto = {
        name: this.name,
        vat: this.vat,
        street: this.street,
        city: this.city,
        zip: this.zip,
        website: this.website,
        email: this.email,
        phone: this.phone,
      };

      this.$vs.loading();

      await this.$store.dispatch("legalDocuments/createProcessor", dto);

      this.$vs.notify({
        color: "success",
        title: `Processor added`,
        text: "Processor added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
